<template>
  <div v-if="visible" class="release-overlay">
    <span class="release-watermark" :title="'代码版本 ' + shortVersion" aria-label="代码版本">{{ shortVersion }}</span>
    <button v-if="availableRevision" type="button" class="release-notch" @click="refreshVersion"
      aria-label="有新版本，请点击刷新" aria-live="polite">
      <span class="release-dot" aria-hidden="true"></span>
      有新版本，请点击刷新
      <span class="release-arrow" aria-hidden="true">↻</span>
    </button>
  </div>
</template>

<script>
import { createVersionMonitor } from '../services/version-monitor'

const revision = typeof __APP_REVISION__ !== 'undefined' ? __APP_REVISION__ : null
export default {
  name: 'ReleaseNotice',
  data () {
    return { visible: true, availableRevision: null, shortVersion: revision ? revision.slice(0, 6) : 'dev000' }
  },
  mounted () {
    if (!revision) return
    // Desktop renders the application in a same-origin phone frame; poll only in the visible app.
    const desktopFrame = document.getElementById('pc-mobile-frame')
    if (window.self === window.top && desktopFrame && desktopFrame.getAttribute('src') && desktopFrame.getAttribute('src') !== 'about:blank') {
      this.visible = false
      return
    }
    this.versionMonitor = createVersionMonitor({
      revision,
      onChange: latest => { this.availableRevision = latest }
    })
    this.versionMonitor.start()
  },
  beforeDestroy () {
    if (this.versionMonitor) this.versionMonitor.stop()
  },
  methods: {
    refreshVersion () {
      if (!this.availableRevision) return
      const url = new URL(window.location.href)
      url.searchParams.set('__v', this.availableRevision.slice(0, 12))
      try {
        if (window.top !== window && window.top.location.origin === window.location.origin) {
          window.top.location.replace(url.href)
          return
        }
      } catch (error) { /* Cross-origin embeds refresh only their own frame. */ }
      window.location.replace(url.href)
    }
  }
}
</script>

<style scoped>
.release-overlay { position: fixed; inset: 0; z-index: 2147483000; pointer-events: none; }
.release-watermark {
  position: absolute; top: calc(env(safe-area-inset-top, 0px) + 4px); right: calc(env(safe-area-inset-right, 0px) + 6px);
  padding: 0; margin: 0; border: 0; background: transparent; color: rgba(65, 76, 103, .48);
  font: 10px/1.2 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: .5px; user-select: none; pointer-events: none;
}
.release-notch {
  position: absolute; top: 0; left: 50%; transform: translateX(-50%); pointer-events: auto;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  box-sizing: border-box; max-width: calc(100vw - 100px);
  padding: calc(env(safe-area-inset-top, 0px) + 8px) 13px 9px;
  border: 0; border-radius: 0 0 17px 17px; background: #202536; color: #fff;
  box-shadow: 0 3px 10px rgba(25, 33, 60, .18); cursor: pointer;
  font-size: 12px; line-height: 18px; font-weight: 500; white-space: nowrap;
}
.release-notch:focus-visible { outline: 2px solid #168bff; outline-offset: 2px; }
.release-dot { width: 5px; height: 5px; border-radius: 50%; background: #8ec7ff; flex: 0 0 5px; }
.release-arrow { font-size: 16px; line-height: 18px; }
</style>



// WEBPACK FOOTER //
// src/components/ReleaseNotice.vue